import {DataTableColumn} from 'mantine-datatable';
import {NavLink} from 'react-router-dom';
import {I18n} from '@aws-amplify/core';
import {Code} from '@mantine/core';

import {formatTimestamp} from '../../../utils/TableTimestamps.tsx';
import {TestingAction} from '../types.ts';
import {ActionStatusBadge} from '../profile/ActionStatusBadge.tsx';
import {ApplicationName} from '../../testing-api-integration/components/ApplicationName.tsx';
import config from '../config';

export const useTestingActionsTableColumns = () => {

    const columns: DataTableColumn<TestingAction>[] = [
        {
            accessor: 'actionCode',
            title: I18n.get('Action Code'),
            width: '1fr',
            render: (item: TestingAction) => (
                <NavLink to={`${config.basePath}/${item.id}`}>
                    <Code>{item.actionCode}</Code>
                </NavLink>
            ),
        },
        {
            accessor: 'name',
            title: I18n.get('Name'),
            width: '1fr',
            render: (item: TestingAction) => item.name,
        },
        {
            accessor: 'applicationId',
            title: I18n.get('Target Application'),
            width: '1fr',
            // Shows the application NAME, resolved from the console catalog.
            // Falls back to the raw id when it cannot be resolved (archived, or
            // not visible to this operator) so a dangling reference stays
            // VISIBLE — a blank cell would read as "no application", which is a
            // different and misleading fact.
            render: (item: TestingAction) => <ApplicationName applicationId={item.applicationId}/>,
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            width: '120px',
            render: (item: TestingAction) => <ActionStatusBadge status={item.status}/>,
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: TestingAction) => formatTimestamp(item.created),
        },
    ];

    return {
        columns,
    };
};
